<template>
  <div class="bet-slip-bet-place-line-changed--content bet-slip-fixed-content">
    <div class="confirmation-wrapper">
      <line-changed-desc />

      <div class="rows-wrapper">
        <bet-slip-confirmation
          :bet-response-source="getChangedBets()"
          :showCheckBoxes="true"
          :isLinesChangedItem="true"
          :is-confirmation="false"
        ></bet-slip-confirmation>
      </div>

      <template v-if="getClosedBets().length > 0">
        <div class="rows-wrapper">
          <bet-slip-confirmation :bet-response-source="getClosedBets()" :closedBets="true"></bet-slip-confirmation>
        </div>
      </template>

      <template v-if="getSuccessfullyPlacedBets().length > 0">
        <div class="rows-wrapper">
          <bet-slip-confirmation
            :bet-response-source="getSuccessfullyPlacedBets()"
            :showSuccess="true"
            :placedIndicator="true"
          ></bet-slip-confirmation>
        </div>
      </template>

      <div>
        <a
          class="btn btn-large btn-orange mt-3"
          :disabled="betPlaceStatus.loading || hasConfirmationError()"
          @click.prevent="innerPlaceBet()"
          :class="{
            'btn-loading-anim disabled': betPlaceStatus.loading,
          }"
        >
          <span v-if="!betPlaceStatus.loading" class="text-uppercase">{{
            isLinesChanged ? $t('BetSlip.AcceptAll') : $t('DepositView.ACH.Step2.ButtonContinue')
          }}</span>
          <span v-if="!!countDown" class="mr-2"> {{ countDown }}</span>
          <i class="fa fa-spin fa-spinner" v-if="betPlaceStatus.loading"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import BetSlipConfirmation from './BetSlipConfirmation';
import { ExternalWagerLoginTypes } from '@/utils/enums';
import ConfirmationModal from '@/components/shared/BonusModal';
import { isLive } from '@/views/sports/components/bet-slip/check-bets';
import { uniqBy } from 'lodash';
import LineChangedDesc from './LineChangedDesc';

export default {
  components: {
    LineChangedDesc,
    BetSlipConfirmation,
    ConfirmationModal,
  },
  data() {
    return {
      countDown: null,
      timer: null,
    };
  },
  watch: {
    betPlaceStatus: function(value) {
      if (value && value.loading === true && this.liveCount) {
        this.startTimer();
      }

      if (value && value.loading === false) {
        clearTimeout(this.timer);
      }
    },
  },
  computed: {
    ...mapState({
      currentState: state => state.betSlip.currentState,
      betOptionsResponse: state => state.betSlip.betOptionsResponse,
      betOptionsStatus: state => state.betSlip.betOptionsStatus,
      betConfirmationResponse: state => state.betSlip.betConfirmationResponse,
      betPlaceResponse: state => state.betSlip.betPlaceResponse,
      betPlaceStatus: state => state.betSlip.betPlaceStatus,
      selectedLocale: state => state.settings.selectedLocale,
      betConfirmationDisabledLines: state => state.betSlip.betConfirmationDisabledLines,
      betConfirmationIds: state => state.betSlip.betConfirmationIds,
      loginType: state => state.player.loginType,
    }),
    ...mapGetters({
      liveBetDelay: 'settings/liveBetDelay',
    }),
    isDepositUser() {
      return this.loginType === ExternalWagerLoginTypes.DepositTicket;
    },
    liveCount() {
      return this.betConfirmationResponse.reduce(
        (acc2, curr2) =>
          acc2 + curr2.bet.line_selections.reduce((acc, curr) => acc + !!isLive(curr.selection_identifier), 0),
        0,
      );
    },
    isLinesChanged() {
      let isChanged = false;
      const betPlaceIds = (this.betPlaceResponse || [])
        .filter(bet => !bet.IsSuccess && bet.ErrorMessageKey === 'GAMELINECHANGE')
        .map(bet => bet.bet.id);

      betPlaceIds.forEach(betPlaceId => {
        if (!this.betConfirmationIds.find(a => +a === +betPlaceId)) {
          isChanged = true;
        }
      });
      return isChanged;
    },
  },
  methods: {
    ...mapActions({
      clearBetSlip: 'betSlip/clearBetSlip',
      placeBet: 'betSlip/placeBet',
      logoutAndRefresh: 'player/logoutAndRefresh',
    }),
    ...mapMutations({
      setCurrentState: 'betSlip/setCurrentState',
      resetBetSlip: 'betSlip/resetBetSlip',
    }),
    hasConfirmationError() {
      return this.betConfirmationResponse.filter(row => !!row.error).length > 0;
    },
    getChangedBets() {
      return this.betPlaceResponse.filter(
        row => !row.IsSuccess && row.ErrorMessageKey === 'GAMELINECHANGE',
      );
    },
    getSuccessfullyPlacedBets() {
      return this.betPlaceResponse.filter(row => row.IsSuccess);
    },
    getClosedBets() {
      return this.betPlaceResponse.filter(
        row => row.IsSuccess && row.ErrorMessageKey === '_WSP_LINE_NO_LONGER_AVAILABLE',
      );
    },
    tryLogout() {
      if (this.loginType === ExternalWagerLoginTypes.DepositTicket) {
        this.logoutAndRefresh(this.$isElectron);
      }
    },
    countDownTimer() {
      if (this.countDown > 0 && this.liveCount > 0) {
        this.timer = setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },
    startTimer() {
      if (this.liveBetDelay >= 3) {
        this.countDown = this.liveBetDelay;
        this.countDownTimer();
      }
    },
    closeModal() {
      this.$store.commit('betSlip/setCurrentState', 'BET_PREPARE');
    },
    innerPlaceBet() {
      if (this.isLinesChanged) {
        this.betPlaceResponse
          .filter(bet => bet && !bet.IsSuccess && bet.ErrorMessageKey === 'GAMELINECHANGE')
          .forEach(bet => {
            this.$store.commit('betSlip/addBetConfirmationId', bet);
          });
      }

      this.placeBet();
    },
  },
};
</script>
